import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementAppGroupIdEmailTemplatesIdPreviewThumbnail } from "./constants";
import type {
  GetEngagementAppGroupIdEmailTemplatesIdPreviewThumbnailProps,
  GetEngagementAppGroupIdEmailTemplatesIdPreviewThumbnailResult,
} from "./types";
import { isGetEngagementAppGroupIdEmailTemplatesIdPreviewThumbnailResult } from "./validators";

/**
 * GET handler for the "/engagement/:app_group_id/email_templates/:id/preview_thumbnail" endpoint
 */
export const getEngagementAppGroupIdEmailTemplatesIdPreviewThumbnail = reactQueryFetcherAdapter(
  engagementAppGroupIdEmailTemplatesIdPreviewThumbnail,
  (
    signal: AbortSignal,
    { appGroupId, id, previewVersion }: GetEngagementAppGroupIdEmailTemplatesIdPreviewThumbnailProps
  ): Promise<GetEngagementAppGroupIdEmailTemplatesIdPreviewThumbnailResult> => {
    return fetch(
      `/engagement/${appGroupId}/email_templates/${id}/preview_thumbnail`,
      "GET",
      { v: previewVersion },
      { signal },
      { propagateFetchRequestError: false }
    );
  },
  isGetEngagementAppGroupIdEmailTemplatesIdPreviewThumbnailResult
);
